export default __webpack_public_path__ + "static/media/UpperGI_tilt_set_up_Male.98648e6a.png";